import { render } from "./LoginCopyright.vue?vue&type=template&id=34533076"
import script from "./LoginCopyright.vue?vue&type=script&lang=js"
export * from "./LoginCopyright.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__